import { ReactElement } from 'react'

import { BaseScheduleIndex } from '../../../../../@paco/entities/BaseSchedule/BaseSchedule'

const transformBaseSchedulesToOptions = (baseSchedules: BaseScheduleIndex[]): ReactElement[] => baseSchedules.map(baseSchedule => (
    <option key={baseSchedule.id} value={baseSchedule.id}>
        {baseSchedule.name}
    </option>
))

export default transformBaseSchedulesToOptions
